<div class="main-container">
  <img src="/assets/images/loading.gif" class="loader" />
  <ngx-extended-pdf-viewer
    *ngIf="pdfSrc"
    [src]="pdfSrc"
    style="display: block"
  ></ngx-extended-pdf-viewer>
</div>
